import { render, staticRenderFns } from "./ExibirNoticiasView.vue?vue&type=template&id=5aa2e198"
import script from "./ExibirNoticiasView.vue?vue&type=script&lang=js"
export * from "./ExibirNoticiasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports